/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/order */
/* eslint-disable camelcase */
import { sentenceCase } from 'change-case';
import { useState, useCallback, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import {
  Card,
  Table,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  Box,
  CircularProgress,
  Chip,
  Link
} from '@mui/material';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDate, fDateTime } from 'utils/formatTime';
import AddAdminModal from 'sections/@dashboard/admin/AddAdminModal';
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
import { useTheme } from '@mui/material/styles';

// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Iconify from '../../components/Iconify';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import { LoadingButton } from '@mui/lab';
import Swal from 'sweetalert2'
import AppColors from "utils/AppColors";
import { handleSelectClick } from 'utils/commonFunc';
// import AddCryptoModal from 'sections/@dashboard/crypto/AddCryptoModal';
// import SetCryptoRateModal from 'sections/@dashboard/crypto/SetExchangeRateModal';
// import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
// import { fNumber } from 'utils/formatNumber';
// import AddPaymentWalletAdressModal from 'sections/@dashboard/crypto/AddPaymentWalletAdressModal';
import AddFeaturedBlogPostsModal from 'sections/@dashboard/featured-posts/AddFeaturedBlogPostsModal';
import useAuth from 'hooks/useAuth';
import CreatePostDialog from 'sections/@dashboard/featured-posts/AppPostPostDialog';

// ----------------------------------------------------------------------



// const copyText = (str) => {
//   const el = document.createElement('input');
//   el.value = str;
//   el.style="width:1px;position:absolute;bottom:0px,left:0px";
//   document.body.appendChild(el);
//   el.select();
//   document.execCommand('copy');
//   document.removeChild(el);
// }


export default function AppPostContents() {
  // const theme = useTheme();
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  const [modal, setModal] = useState({open:false, data:{}});
  const [dataList, setdataList] = useState([]);
  const [state,setState] = useState({loading:false,loadComplete:false,error:null, isDeleting: false});
  const [selected,setSelected] = useState([]);
  const { user } = useAuth();


  const getInitData = useCallback(async () => {
    
    setState({...state,loading:true,loadComplete:false,error:null})

    try {
      const response = await axios.get(CRUD.appContent.appPosts);

      if (isMountedRef.current) {
        setdataList(response.data);
      }
      setState({...state,loading:false,loadComplete:true,error:null})
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  }, [isMountedRef]);

  useEffect(() => {
    getInitData();
  }, [getInitData]);

  return (
    <Page title="InApp Posts">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Post Content"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Featured posts' },
            // { name: 'Exchange Rates' }
          ]}
          action={
            <Button sx={{ml:2}}
              variant="contained"
              component={Button}
              disabled={!user.is_admin}
              onClick={()=>{
                setModal({open:true, isEdit: false});
              }}
              startIcon={<Iconify icon={'eva:plus-fill'} />}
            >
              Create a Post
            </Button>
          }
        />

        {state.loading && (
          <Card>
             <Box padding={10} display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Box>
          </Card>
        )}

        {!state.loading && state.error !=null && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p>Error {state.error} </p>
            </Box>
          </Card>
        )}

        {state.loadComplete && dataList.length < 1 && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p> There's nothing here yet </p>
            </Box>
          </Card>
        )}

        {state.loadComplete && <Card>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{" "}</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Created By</TableCell>
                    <TableCell>Create at</TableCell>
                    <TableCell>{" "}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataList.map((row) => {
                    // const { id, first_name, last_name, role, email, status, image_url, seen_at } = row;
                    const isItemSelected = selected.indexOf(row.id) !== -1;

                    return (
                      <TableRow
                        hover
                        key={row.id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox checked={isItemSelected} onClick={() => handleSelectClick(row.id, selected, setSelected)} />
                        </TableCell>
                        <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                            <Link href={row.url} target='_blank'> {row.title} </Link>
                        </TableCell>
                        <TableCell align="left"> {row.staff_name} </TableCell>
                        <TableCell align="left">{fDateTime(row.created_at)}</TableCell>

                        {user.is_admin && <TableCell align="right">
                          <Button
                            onClick={() =>{
                              setModal({open:true,postId:row.post_id, isEdit:true});
                            }}
                            variant="outlined" color="secondary"
                            >
                             Edit
                          </Button>
                          <Button sx={{ml:1}}
                            type="submit" 
                            onClick={()=> removeEntry(row)}
                            variant="outlined" color="error"
                            >
                            <Iconify icon={'eva:trash-2-outline'} sx={{  mr: 2, width: 20,height: 20,}} /> Delete
                          </Button>
                        </TableCell>}
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )} */}
                </TableBody>
                
                {state.loadComplete && dataList.length < 1 && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Box sx={{padding: 7}}>
                          <Typography>
                            Nothing here yet.
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

        </Card>}
      </Container>


     {modal.open &&  <CreatePostDialog
        open={modal.open}
        postId={modal.postId}
        handleClose={()=>{
          setModal({open:false});
        }}
        handleComplete={()=>{
          setModal({open:false});
          getInitData();
        }}
         />}

    </Page>
  );


  function removeEntry(row){
    Swal.fire({
        text: "Do you want to remove this entry?",
        icon: 'warning',
        showCancelButton: true,
        // eslint-disable-next-line import/no-named-as-default-member
        confirmButtonColor: AppColors.DANGER,
        confirmButtonText: "Yes, contine",
        reverseButtons: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: async ()  =>  {
          try {
            await axios.delete(`${CRUD.appContent.appPosts}/${row.post_id}`);
            const data = dataList.filter(e=>e.id !== row.id);
            setdataList(data);
            return true;
          } catch (error) {
            Swal.showValidationMessage(
                `${getErrorMessage(error) || error.toString()}`
            );
            return false;
          }
        },
    }).then((result) => {
        if (result.value) {
            Swal.close();
        } 
    });

  }


}
